// extracted by mini-css-extract-plugin
export default {"root":"CoursePauseScheduledTableRow_root__o04Xg","cell":"CoursePauseScheduledTableRow_cell__fS3Ap","action":"CoursePauseScheduledTableRow_action__pdYOz"};